import React from "react";
import { useFormik } from "formik";

import TextField from "@material-ui/core/TextField";

import StyledButton from "../buttons/StyledButton";

export default function OpenAIOrgForm({
  isSubmitting,
  initialValues,
  onSubmit,
  onCancel,
}) {
  const handleValidateForm = (values) => {
    const errors = {};
    if (!values.openAIApiKey) {
      errors.openAIApiKey = "Please enter the OpenAI API key";
    }

    if (!values.openAIModel) {
      errors.openAIModel = "Please enter the model";
    }

    if (!values.openAIOrgTier) {
      errors.openAIOrgTier = "Please enter the tier of the organization";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: initialValues || {},
    validate: handleValidateForm,
    onSubmit,
  });

  const renderOpenAIOrgForm = () => {
    return (
      <form
        style={{
          padding: "1rem 0",
        }}
        onSubmit={formik.handleSubmit}
      >
        <div style={{}}>
          <TextField
            autoFocus
            variant="outlined"
            fullWidth
            placeholder="OpenAI API key"
            name={"openAIApiKey"}
            required
            value={formik.values["openAIApiKey"]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched["openAIApiKey"] &&
              Boolean(formik.errors["openAIApiKey"])
            }
            helperText={
              formik.touched["openAIApiKey"] && formik.errors["openAIApiKey"]
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "1rem",
            padding: "1rem 0",
          }}
        >
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Model"
            name={"openAIModel"}
            required
            value={formik.values["openAIModel"]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched["openAIModel"] &&
              Boolean(formik.errors["openAIModel"])
            }
            helperText={
              formik.touched["openAIModel"] && formik.errors["openAIModel"]
            }
          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Tier"
            name={"openAIOrgTier"}
            required
            value={formik.values["openAIOrgTier"]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched["openAIOrgTier"] &&
              Boolean(formik.errors["openAIOrgTier"])
            }
            helperText={
              formik.touched["openAIOrgTier"] && formik.errors["openAIOrgTier"]
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            justifyContent: "space-between",
            paddingTop: "1  rem",
          }}
        >
          <div />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <StyledButton type="button" onClick={onCancel}>
              Cancel
            </StyledButton>
            <StyledButton color="primary" type="submit" disabled={isSubmitting}>
              Save
            </StyledButton>
          </div>
        </div>
      </form>
    );
  };

  return renderOpenAIOrgForm();
}
